import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from "@angular/router";
import { SupportService } from '../../../services/support.service';
import { AuthenticationService } from '../../../services/authentication.service';
import { CommonService } from '../../../services/common.service';


export interface SupportCaseReply {
    CreatedDate: Date;
    OwnerImg: string;
    OwnerName: string;
    Description: string;
}

@Component({
  selector: 'app-support-case-detail',
  templateUrl: './support-case-detail.component.html',
  styleUrls: ['./support-case-detail.component.scss']
})
export class SupportCaseDetailComponent implements OnInit {

    constructor(private route: ActivatedRoute,
        private router: Router, private supportService: SupportService,
        private authentication: AuthenticationService,
        private common: CommonService) { }
    id: string = "0";

    errorMessage: string = "";
    isError: boolean = false;

    btnSendDisabled: boolean = false;
    btnSend: string = "Send";

    isCaseLoaded: boolean = false;
    isRepliesLoaded: boolean = false;

    //caseActivityHistory: any[] = [];
    caseActivityHistory: Array<SupportCaseReply> = [];

    activityHistory: any = {
        Description: ""
    };

    caseAttachments: any[] = [];

    files: any = [];

    case: any = {
        Subject: "",
        Contact: { Name: "" },
        Account: { Name: "" },
        Status: "",
        Origin: "",
        OS_Vendor__c: "",
        Operating_System_New__c: "",
        Vendor__c: "",
        Product_Category__c: "",
        Product_Sub_Category__c: "",
        Product_Name__c: "",
        Product_Version__c: "",
        CaseNumber: "",
        LastModifiedDate: "",
        IsSystemDown: false,
        Description: "",
        Owner: { Name: "" },
        SeverityLevel: "",
        SupportType: "",
        IsAdvancedSupport: false
    };

    pagecode: string = "supp-detail";
    module: string = "support";

    accessdenied: boolean = false;

    isLoading: boolean = true;

    ngOnInit(): void {


        this.route.params.subscribe(val => {
            this.authentication.checkUserPageAccess(this.authentication._authentication.id, this.pagecode).subscribe(
                (res: any) => {
                    if (res.success && res.data) {

                        var pageURL = this.router.routerState.snapshot.url;
                        this.authentication.addUserPageView(pageURL, this.pagecode, this.module);

                        let map: any = this.route.paramMap;
                        this.id = map.destination._value.id;

                        this.getCaseBySFID();
                        this.getCaseActivityHistory();
                        this.getCaseAttachment();

                        window.scroll(0, 0);

                    }
                    else {
                        this.accessdenied = true;
                        this.isLoading = false;
                    }
                },
                (err: any) => {
                    console.error("checkUserPageAccess", err);
                    this.accessdenied = true;
                    this.isLoading = false;
                }
            );


        });



    }

    getCaseBySFID() {
        this.supportService.getCaseBySFID(this.id).subscribe(
            (res: any) => {
                this.isLoading = false;
                if (res.success && res.data != null) {
                    this.case = res.data;
                    console.log("this.case", this.case);
                    this.isCaseLoaded = true;
                }
                else {
                    console.error("Web/Support/Detail/getCaseBySFID()", res.error_message);
                    this.accessdenied = true;
                    this.isLoading = false;
                    this.isCaseLoaded = true;
                }

            },
            (err: any) => {
                this.accessdenied = true;
                this.isLoading = false;
                this.isCaseLoaded = true;
                console.error("Web/Support/Detail/getCaseBySFID()", err);
            }
        );
    }



    getCaseActivityHistory() {
        this.supportService.getCaseActivityHistory(this.id).subscribe(
            (res: any) => {
                console.log("case activities", res);
                debugger;
                if (res.success) {
                    for (var i = 0; i < res.data.length; i++) {
                        this.caseActivityHistory.push({
                            CreatedDate: new Date(res.data[i].createdDate),
                            Description: res.data[i].description,
                            OwnerImg: res.data[i].ownerImg,
                            OwnerName: res.data[i].ownerName
                        });
                    }
                    this.isRepliesLoaded = true;
                }
                else {
                    this.isRepliesLoaded = true;
                    console.error("Web/Support/Detail/getCaseBySFID()", res.error_message);
                }
            },
            (err: any) => {
                this.isRepliesLoaded = true;
                console.error("Web/Support/Detail/getCaseActivityHistory()", err);
            }
        );
    }

    getCaseAttachment() {
        this.supportService.getCaseAttachments(this.id).subscribe(
            (res: any) => {
                for (let i = 0; i < res.length; i++) {
                    res[i].href = "data:" + res[i].ContentType + ";base64," + res[i].Body;
                }
                this.caseAttachments = res;
            },
            (err: any) => {
                console.error("Web/Support/Detail/getCaseAttachment", err);
            }
        );
    }

    downloadAttachment(href: any, name: any) {
        var link = document.createElement('a');
        link.href = href;
        var fileName = name;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

    submitCaseAttachments() {

        var files = this.files;
        var attachmentsObj = {
            ParentId: this.id,
            attachments: []
        };
        for (var i = 0; i < files.length; i++) {
            var file = files[i];
            var isLastIndex = false;
            if (i == files.length - 1)
                isLastIndex = true;
            this.getFile(file, attachmentsObj, isLastIndex);
        }

    }


    getFile(file: any, attachmentsObj: any, isLastIndex: any) {

        var reader = new FileReader();
        let _self = this;
        reader.onload = function (readerEvt) {

            var binaryString = readerEvt['target']!['result']!.toString().split(',')[1];
            //var binaryString = "";
            var contentType = file.type;
            if (file.name.toLowerCase().indexOf(".zip") !== -1 && file.type === "")
                contentType = "application/x-zip-compressed";
            attachmentsObj.attachments.push({
                ContentType: contentType,
                Name: file.name,
                Body: binaryString
            });

            if (isLastIndex) {
                _self.files = [];
                _self.supportService.addAttachment(attachmentsObj).subscribe(
                    (res: any) => {
                        _self.getCaseAttachment();
                    },
                    (err: any) => {
                        console.error("getFile addAttachment", err);
                    }
                );
            }
        };
        reader.readAsDataURL(file);
    }

    removeFile(fileIndex: any) {
        this.files.splice(fileIndex, 1);
    }

    filesSelect(selectedFiles: any): void {

        for (var i = 0; i < selectedFiles.target.files.length; i++) {
            this.files.push(selectedFiles.target.files[i]);
        }
    }


    sendActivityHistory() {
        debugger;
        if (this.activityHistory.Description != "") {
            this.btnSendDisabled = true;
            this.btnSend = "Sending";
            this.activityHistory.caseId = this.case.Id;
            this.activityHistory.Subject = this.case.Subject;
            this.activityHistory.Status = "Completed";
            this.activityHistory.Type = "Web";
            this.activityHistory.Priority = "Normal";
            this.activityHistory.WhoId = this.authentication._authentication.id;
            this.activityHistory.ActivityDate = new Date();

            if (this.files.length > 0)
                this.submitCaseAttachments();

            let _self = this;
            this.supportService.addCaseActivityHistory(this.activityHistory).subscribe(
                (res: any) => {
                    
                    if (res.success) {
                        if (res.data != null) {
                            _self.activityHistory.Description = "";
                            debugger;

                            this.caseActivityHistory.push({
                                CreatedDate: new Date(res.data.createdDate),
                                Description: res.data.description,
                                OwnerImg: res.data.ownerImg,
                                OwnerName: res.data.ownerName
                            });
                            console.log("this.caseActivityHistory", this.caseActivityHistory);
                            //res.data['activityObject'].open = true;
                            //this.caseActivityHistory.push(res.data['activityObject']);
                        }
                        //this.getCaseActivityHistory();
                    }
                    else {
                        console.error("Web/Support/Detail/sendActivityHistory()", res.error_message);
                    }
                    _self.btnSendDisabled = false;
                    _self.btnSend = "Send";
                },
                (err: any) => {
                    console.error("Web/Support/Detail/sendActivityHistory()", err);
                    _self.btnSendDisabled = false;
                    _self.btnSend = "Send";
                }
            );

        }
        else {
            this.common.ShowMessage('error', 'your reply is mandatory', '');
        }
    }

}